import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class Product extends Resource {
    public override type = 'products';

    @prop()
    public code!: string;

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public price!: number;

    @prop()
    public module!: string;
}
